import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { DropdownDownIcon, DropdownUpIcon } from 'util/icons';
import { palette } from 'util/style-helpers';
import { style } from './style';

export interface ILink {
  text: string;
  sub_text?: string;
  route: string;
  icon?: string;
}

export interface ISubLink {
  text: string;
  route: string;
  icon?: string;
}

export interface Props {
  link: ILink;
  sublinks?: ISubLink[];
  isDropdownOpen?: boolean;
  onDropdownToggle?: () => void;
  onClick?: () => void;
}

export const MobileNavLink: FC<Props> = ({ link, sublinks, isDropdownOpen, onDropdownToggle, onClick }) => {
  const isButton: boolean = !link.route && !!onClick;
  const hasDropdown: boolean = !!sublinks && !!sublinks.length;
  const numberOfSublinks: number = sublinks?.length || 0;
  const styles = style({ isDropdownOpen, numberOfSublinks });

  if (!link.text) return null;

  const onLinkClick = (): void => {
    if (onClick) onClick();
  };

  const getButton = (): JSX.Element => {
    return (
      // eslint-disable-next-line
      <a className={css(styles.defaultLink)} onClick={onLinkClick}>
        <span className={css(styles.defaultLinkContent)}>
          {link.icon && <img src={link.icon} alt={link.text} />}
          {link.text} {link.sub_text && <span>{link.sub_text}</span>}
        </span>
      </a>
    );
  };

  const getLink = (): JSX.Element => {
    const isExternalLink: boolean = link.route.trim().charAt(0) !== '/';
    return (
      <Link
        to={isExternalLink ? { pathname: link.route } : link.route}
        rel={isExternalLink ? 'noopener' : undefined}
        target={isExternalLink ? '_blank' : undefined}
        onClick={() => onLinkClick()}
        className={css(styles.defaultLink)}>
        <span className={css(styles.defaultLinkContent)}>
          {link.icon && <img src={link.icon} alt={link.text} />}
          {link.text} {link.sub_text && <span>{link.sub_text}</span>}
        </span>
      </Link>
    );
  };

  const getDropdown = (): JSX.Element => {
    return (
      <div className={css(styles.dropdownLinkContainer)}>
        <div className={css(styles.dropdownLinkHeader)} onClick={() => onDropdownToggle && onDropdownToggle()}>
          <span dangerouslySetInnerHTML={{ __html: link.text }}></span>
          <div className={css(styles.dropdownArrowIndicator)}>
            {isDropdownOpen ? <DropdownUpIcon color={palette.red} /> : <DropdownDownIcon color={palette.red} />}
          </div>
        </div>
        <div className={css(styles.dropdownContainer)}>
          {sublinks!.map((sublink: ISubLink, index: number) => {
            return (
              <Link key={index} className={css(styles.dropdownLink)} to={sublink.route} onClick={() => onLinkClick()}>
                <span className={css(styles.dropdownLinkContent)}>
                  {sublink.icon && <img src={sublink.icon} alt={sublink.text} />}
                  {sublink.text}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    );
  };

  return isButton ? getButton() : hasDropdown ? getDropdown() : getLink();
};
